/**
 * Activity Model
 * @author tbroussard
 *
 * This needs to manage:
 *	 - viewContext
 *	 - country
 *	 - showDetailedView
 *	 - hasTransactionsPending
 *	 - hasTransactionsCompleted
 *	 - noOfTransactions
 *	 - showLoadMore
 *	 - statementLinks
 *	 √ error
 *
 *	 Take all that junk out of the TransactionCollectionView and make this
 *	 model the place for handling it.
 */
import Backbone from 'backbone';

export default Backbone.Model.extend({
	defaults: {
		data: {
			activity: {
				error: null
			}
		}
	},

	/**
	 * Update error with data from latest response, or null if no error
	 * happened
	 */
	setError(error = null) {
		// unpack it
		let dataObj = this.get('data');
		// set it
		dataObj.activity.error = error;
		// register it
		this.set('data', dataObj);
	},

	/**
	 * @return null or some error (as the string that it came in as)
	 */
	hasError() {
		return this.get('data').activity.error;
	}
});



// WEBPACK FOOTER //
// ./model/activity/activityModel.es6